import React, {useEffect, useState} from 'react';
import {IREACT_SELECT, ITabs, USER_ACTION} from '@src/types';
import '@components/ProductJourney/product-journey.scss';
import {useDispatch, useSelector} from 'react-redux';
import {getParams, translate} from '@src/helpers';
import ProductTemplateAnswerV2 from "@components/ProductTemplate/Answer/ProductTemplateAnswerV2";
import _ from "lodash-es";
import {DEFAULT_SELECT} from "@src/variables";
import {setFooterSticky} from "@redux/actions/footerAction";
import POSMapV2 from "@components/module-components/POSMap/POSMapV2";
import VerificationLegend from "@components/VerificationLegend/VerificationLegend";
import DetailedViewV2 from "@components/module-components/DetailedView/DetailedViewV2";
import {ENV} from "@environments/environment";
import {formatDataMap} from "@components/ProductJourney/helper";

const {AWS_S3_FILE_UPLOAD, API_URL, GG_KEY} = ENV

const productDetailViewIconSVG = () => {
  return <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.3996 11.9994H9.59961M26.3996 21.5994H9.59961M26.3996 2.39941H9.59961"
      stroke="black"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.3976 4.8C3.5976 4.8 4.7976 3.6 4.7976 2.4C4.7976 1.2 3.5976 0 2.3976 0C1.1976 0 0 1.2 0 2.4C0 3.6 1.1976 4.8 2.3976 4.8ZM2.3976 14.4C3.5976 14.4 4.7976 13.2 4.7976 12C4.7976 10.8 3.5976 9.6 2.3976 9.6C1.1976 9.6 0 10.8 0 12C0 13.2 1.1976 14.4 2.3976 14.4ZM2.3976 24C3.5976 24 4.7976 22.8 4.7976 21.6C4.7976 20.4 3.5976 19.2 2.3976 19.2C1.1976 19.2 0 20.4 0 21.6C0 22.8 1.1976 24 2.3976 24Z"
      fill="black"
    />
  </svg>

}

const productMapViewIconSvg = () => {
  return <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.315 3.36287L29.4323 0V20.321L19.315 23.6982L10.1174 20.6371L0 24V3.67904L10.1174 0.301796L19.315 3.36287ZM11.0371 2.54371V18.9988L18.3952 21.4563V5.0012L11.0371 2.54371ZM1.83952 5.0012V21.4563L9.19761 18.9988V2.54371L1.83952 5.0012ZM27.5928 18.9988V2.54371L20.2347 5.0012V21.4563L27.5928 18.9988Z"
      fill="black"/>
  </svg>

}

const productProductsViewIconSvg = () => {
  return <svg width="173" height="129" viewBox="0 0 173 129" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M161.556 0.166687H11.4445C8.60079 0.166687 5.87359 1.29629 3.86279 3.30709C1.85189 5.31789 0.72229 8.04519 0.72229 10.8889V118.111C0.72229 120.955 1.85189 123.682 3.86279 125.693C5.87359 127.704 8.60079 128.833 11.4445 128.833H161.556C164.399 128.833 167.127 127.704 169.137 125.693C171.148 123.682 172.278 120.955 172.278 118.111V10.8889C172.278 8.04519 171.148 5.31789 169.137 3.30709C167.127 1.29629 164.399 0.166687 161.556 0.166687ZM161.556 118.111H11.4445V10.8889H161.556V118.111Z"
      fill="black"/>
    <path
      d="M38.2501 43.0556H134.75C136.172 43.0556 137.536 42.4907 138.541 41.4853C139.546 40.4799 140.111 39.1163 140.111 37.6945C140.111 36.2726 139.546 34.909 138.541 33.9036C137.536 32.8982 136.172 32.3333 134.75 32.3333H38.2501C36.8282 32.3333 35.4646 32.8982 34.4592 33.9036C33.4538 34.909 32.889 36.2726 32.889 37.6945C32.889 39.1163 33.4538 40.4799 34.4592 41.4853C35.4646 42.4907 36.8282 43.0556 38.2501 43.0556Z"
      fill="black"/>
    <path
      d="M38.2501 64.4999H134.75C136.172 64.4999 137.536 63.9351 138.541 62.9297C139.546 61.9243 140.111 60.5607 140.111 59.1388C140.111 57.717 139.546 56.3533 138.541 55.3479C137.536 54.3425 136.172 53.7777 134.75 53.7777H38.2501C36.8282 53.7777 35.4646 54.3425 34.4592 55.3479C33.4538 56.3533 32.889 57.717 32.889 59.1388C32.889 60.5607 33.4538 61.9243 34.4592 62.9297C35.4646 63.9351 36.8282 64.4999 38.2501 64.4999Z"
      fill="black"/>
    <path
      d="M38.2501 85.945H91.861C93.283 85.945 94.647 85.38 95.652 84.374C96.657 83.369 97.222 82.005 97.222 80.583C97.222 79.162 96.657 77.798 95.652 76.793C94.647 75.787 93.283 75.222 91.861 75.222H38.2501C36.8282 75.222 35.4646 75.787 34.4592 76.793C33.4538 77.798 32.889 79.162 32.889 80.583C32.889 82.005 33.4538 83.369 34.4592 84.374C35.4646 85.38 36.8282 85.945 38.2501 85.945Z"
      fill="black"/>
  </svg>
}

enum EJourneyType {
  MapView = 0,
  DetailView = 1,
  ProductsView = 2,
}

const JourneyTabMapping = {
  [EJourneyType.MapView]: {
    value: 0,
    display: 'B2C.TAB.MAP_VIEW',
    icon: productDetailViewIconSVG(),
    className: 'journey-map-view',
    queryString: {
      viewMode: "mapView"
    }
  },
  [EJourneyType.DetailView]: {
    value: 1,
    display: 'B2C.TAB.DETAILED_VIEW',
    icon: productMapViewIconSvg(),
    className: 'journey-detail-view',
    queryString: {
      viewMode: "detailView"
    }
  },
  [EJourneyType.ProductsView]: {
    value: 2,
    display: 'B2C.TAB.DETAILED_PRODUCT',
    icon: productProductsViewIconSvg(),
    className: "journey-products-view",
    queryString: {
      viewMode: "detailProducts"
    }
  },
}

const viewModeMapping = {
  mapView: 0,
  detailView: 1,
  detailProducts: 2
}

const ProductJourney = React.forwardRef(({
                                           dataMap,
                                           dataDetail,
                                           dataDetailRaw,
                                           productDetail,
                                           id,
                                           isShowEco = 0
                                         }: any, tabRef: any) => {
  const langData = useSelector((state: any) => state.currentLanguage) as any;
  const [selectedTab, setTab] = useState(parseInt(tabRef.current) || 0);
  const navigatorHelp = useSelector((state: any) => state.navigatorHelper) as any;

  const dispatch = useDispatch();
  const [templates, setTemplates] = useState({...DEFAULT_SELECT})
  const [questions, setQuestions] = useState({
    selected: [],
    list: [],
  } as any);

  const handleTabs = (val: any) => {
    setTab(val);

    // let t = JourneyTabMapping[val as EJourneyType]

    dispatch(setFooterSticky());
  }

  const [dataTabs, setDataTabs] = useState([
    JourneyTabMapping[EJourneyType.MapView],
    JourneyTabMapping[EJourneyType.DetailView]
  ] as ITabs[]);

  const productTemplateHandle = {
    getBatch: async (extra = {}) => {
      let tp = {...templates};

      try {
        /**
         * Handle logic to fetch templateList here
         */
        return tp;
      } catch (e) {
        console.error(e)
        return tp;
      }
    },
    getCurrentTemplates: async (data: any) => {
      try {
        let tp = {...templates}, q = {...questions};
        let {attributeTemplateValue} = data;

        if (_.isArray(attributeTemplateValue) && !_.isEmpty(attributeTemplateValue)) {
          setQuestions({...questions, list: [...attributeTemplateValue]})
          return attributeTemplateValue;
        }
      } catch (e) {
        console.error(e)
      }
    },

  }

  useEffect(() => {
    (async () => {
      let tpl: IREACT_SELECT = await productTemplateHandle.getBatch()

      const {attributeTemplateValue} = productDetail;

      if (!_.isEmpty(attributeTemplateValue) && !_.find(dataTabs, (t) => t.value === 2)) {
        dataTabs.push(JourneyTabMapping[EJourneyType.ProductsView])
      }

      await productTemplateHandle.getCurrentTemplates({attributeTemplateValue});

      if (_.isArray(attributeTemplateValue) && !_.isEmpty(attributeTemplateValue)) {
        if (!_.isEmpty(tpl.list)) {
          tpl.selected = attributeTemplateValue.map((v: any) => {
            let {uid, name} = v;
            return {...v, value: uid, label: name}
          })
          setTemplates({
            ...templates, ...tpl
          });
        }
      }
    })();
  }, [])

  useEffect(() => {
    if(navigatorHelp.query?.viewMode){
      setTab(viewModeMapping[navigatorHelp.query?.viewMode])
    }
  }, [navigatorHelp.query?.viewMode]);


  return (
    <div className="product-journey" id={id}>
      <div className="product-journey_header">
        <h2 className="product-journey_title title-secondary">
          {/*{translate(langData.localize, Translations['B2C.PRODUCT_DETAIL.FULL_PRODUCT_JOURNEY'])}*/}
          {translate(langData.localize, "LABEL.B2C.DETAIL_VIEW.FULL_JOURNEY")}
        </h2>


        <div className="product-journey_tabsv2">
          {
            dataTabs.map(tab =>
              <div
                key={_.uniqueId("product-journey_tabsv2_")}
                className={`product-journey_tabsv2_item ${selectedTab === tab.value ? "active" : ""}`}
                onClick={() => {
                  handleTabs(tab.value)
                }}
              >
                {tab.icon}
                <span>{translate(langData.localize, tab.display)}</span>
              </div>
            )
          }
        </div>

      </div>


      <div
        className={`product-journey_content ${JourneyTabMapping[selectedTab].className}`}>
        {selectedTab === 0 && <>
            <POSMapV2 data={dataMap}/>
        </>
        }

        {selectedTab === 1 &&
            <DetailedViewV2 dataMap={formatDataMap(dataMap)} dataDetail={dataDetail} dataDetailRaw={dataDetailRaw}
                            isShowEco={isShowEco}/>}

        {selectedTab === 2 && _.map(questions.list, (item, itemIndex) =>
          <div className="template-wrapper-position" key={`template` + itemIndex}>
            <ProductTemplateAnswerV2
              template={item}
              action={USER_ACTION.VIEW}
            />
          </div>
        )}

      </div>

      {selectedTab !== EJourneyType.ProductsView && <VerificationLegend/>}

    </div>
  );
})

export default ProductJourney;
